export const LIGHT = {
  primary: '#418FDE',
  secondary: '#FBAF1A',
  navbar: '#000766',
  cta: '#FBAF1A',
  text: '#3E4C59',
  textSecondary: '#72889D',
  paper: '#FFFFFF',
};

export const DARK = {
  primary: '#418FDE',
  secondary: '#FBAF1A',
  navbar: '#000766',
  cta: '#FBAF1A',
  text: '#fff',
  textSecondary: '#B4C0CB',
  paper: '#2f3742',
};
